import axios from "axios";
import { Feature } from "ol";
import { getMap } from "../GeoLiteMap";
import { IdentifyResultsArray } from "./identifyUtils";

export const identifyWmsBasemap = (config, pixel: number[], baseMap: string): Promise<IdentifyResultsArray> => {
    const layerConfig = config.basemaps.find((conf) => conf.id === baseMap);
    const wmsBasemapConfig = layerConfig && layerConfig.layers[0].type === "WMS" && layerConfig.layers[0].identify;
    if (!wmsBasemapConfig) {
        return;
    }

    return identifyWms(layerConfig, pixel);
};

const identifyWms = (layerConfig, pixel): Promise<IdentifyResultsArray | null> =>
    axios
        .get(layerConfig.url, { params: getWmsParams(layerConfig, pixel) })
        .then((response) => {
            if (response.data.error) {
                throw new Error(response.data.error.message + "\n" + response.data.error.details.join("\n"));
            }
            return parseWmsResult(response.data.features, layerConfig);
        })
        .catch((err) => {
            console.error(err);
            return null;
        });

const parseWmsResult = (features: any[], layerConfig): IdentifyResultsArray => {
    const feature = new Feature();
    feature.setProperties(getWmsFeatureAttributes(features[0].properties, layerConfig.layers[0].identify));

    return [
        [
            layerConfig.layers[0].identify.name,
            [
                {
                    mapLayerId: layerConfig.id,
                    layerId: layerConfig.id,
                    layerName: layerConfig.layers[0].identify.name,
                    feature
                }
            ]
        ]
    ];
};

const getWmsParams = (layerConfig, pixel) => {
    const map = getMap();
    const bb = map.getView().calculateExtent(map.getSize());
    const box = bb[0] + "," + bb[1] + "," + bb[2] + "," + bb[3];
    const size = map.getSize();

    return {
        SERVICE: "WMS",
        request: "GetFeatureInfo",
        QUERY_LAYERS: layerConfig.layers[0].identify.layer,
        LAYERS: layerConfig.layers[0].identify.layer,
        INFO_FORMAT: "application/json",
        VERSION: "1.1.0",
        SRS: "EPSG:" + (layerConfig.spatialReference || 3059),
        BBOX: box,
        X: Math.round(pixel[0]),
        Y: Math.round(pixel[1]),
        WIDTH: size[0],
        HEIGHT: size[1]
    };
};

const getWmsFeatureAttributes = (properties: { [name: string]: any }, config: any) => {
    const attributes = {};
    Object.keys(properties).map((key) => {
        config.fields[key] &&
            (attributes[config.fields[key].alias] = Object.prototype.hasOwnProperty.call(config.fields, key)
                ? config.fields[key].displayFormat.replace("{value}", Number.parseFloat(properties[key]).toFixed(2))
                : properties[key]);
    });

    return attributes;
};
